import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CampaignCard = ({ campaign, onEdit, onViewAnalytics }) => {
  const getStatusColor = () => {
    switch (campaign?.status) {
      case 'active': return 'bg-success text-success-foreground';
      case 'scheduled': return 'bg-warning text-warning-foreground';
      case 'completed': return 'bg-muted text-muted-foreground';
      case 'paused': return 'bg-error text-error-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-elevation-2 transition-smooth hover:shadow-elevation-3">
      <div className="relative h-32 md:h-40 overflow-hidden">
        <Image 
          src={campaign?.image} 
          alt={campaign?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${getStatusColor()}`}>
          {campaign?.status?.charAt(0)?.toUpperCase() + campaign?.status?.slice(1)}
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1 min-w-0">
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-1 line-clamp-1">{campaign?.name}</h3>
            <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">{campaign?.description}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Discount</p>
            <p className="text-sm md:text-base font-semibold text-foreground">{campaign?.discount}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Conversions</p>
            <p className="text-sm md:text-base font-semibold text-foreground">{campaign?.conversions}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Revenue</p>
            <p className="text-sm md:text-base font-semibold text-foreground">{campaign?.revenue}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">ROI</p>
            <p className="text-sm md:text-base font-semibold text-success">{campaign?.roi}</p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
          <Icon name="Calendar" size={14} />
          <span>{campaign?.startDate} - {campaign?.endDate}</span>
        </div>

        <div className="flex gap-2">
          <Button variant="outline" size="sm" fullWidth onClick={() => onEdit(campaign)}>
            Edit
          </Button>
          <Button variant="default" size="sm" fullWidth onClick={() => onViewAnalytics(campaign)}>
            Analytics
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;